module.exports = __webpack_public_path__ + "img/App book Literacy 16.9.2019-min.cce8be80.png";